<mat-card>
  <mat-card-header>
    <mat-card-title>TermWeb Connection</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (editable && editConfiguration) {
      <pub-termweb-connection-settings-form data-testid="form"
                                            [configuration]="editConfiguration" [showButtons]="!tenantId"
                                            [lockUrlClient]="lockUrlClient"
                                            (saveConfiguration)="saveConfiguration($event)">
      </pub-termweb-connection-settings-form>
    }
    @if (!editConfiguration && currentConfiguration) {
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <pub-termweb-status-text></pub-termweb-status-text>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <pub-termweb-connection-settings-display data-testid="display"
                                                   [configuration]=currentConfiguration [editable]="editable"
                                                   (editConfiguration)="setEditConfig($event)">
          </pub-termweb-connection-settings-display>
        </mat-expansion-panel>
      </mat-accordion>
    }
  </mat-card-content>
</mat-card>
